import React, { useState } from 'react'
import { Box, Tabs, TextInput, FileInput, Text, Flex, Paper, Image, Group, Button } from '@mantine/core'
import { addImageProductUrl, addImageProductUpload } from '../../../../../services/products'
import NoImage from '../../../../../assets/img/images/no-images.png'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'

const FormAddImageProduct = ({ idProduct, onCloseForm, reloadDetail }) => {
  const [selectedMethodAdjustImage, setSelectedMethodAdjustImage] = useState('url')
  const [imageUrl, setImageUrl] = useState('')
  const [uploadImage, setUploadImage] = useState(null)
  const [renderImageUpload, setRenderImageUpload] = useState(null)
  const [loadingSubmit, setLoadingSubmit] = useState(false)

  const submitAddImageProduct = async () => {
    setLoadingSubmit(true)
    let methodFunction = null
    const titleMessageSuccess = 'Add Image Product Success'
    const captionMessageSuccess = 'You have successfully added image product'
    const titleMessageError = 'Add Image Product Failed'
    let captionMessageError = ''
    if (selectedMethodAdjustImage === 'url') {
     const payload = {
        data: [
          {
            id: idProduct,
            relationships: [
              {
                type: 'images_url',
                urls: [imageUrl],
              },
            ],
          },
        ],
      }
      methodFunction = addImageProductUrl(payload)
    } else {
      const formData = new FormData()
      formData.append(`images[0]`, uploadImage)
      methodFunction = addImageProductUpload(idProduct, formData)
    }
    try {
      const response = await methodFunction
      if (response.success) {
        notificationSuccess(titleMessageSuccess, captionMessageSuccess)
        onCloseForm()
        reloadDetail()
      }
    } catch (error) {
      console.log(error)
      captionMessageError = error?.response?.data?.message || 'There was an error while adding image product.'
      notificationError(titleMessageError, captionMessageError)
    } finally {
      setLoadingSubmit(false)
    }
  }

  const handleUploadImage = (file) => {
    if (file !== null) {
      const fileEncoded = file
      const fileSizeInBytes = file.size
      const fileSizeInMB = (fileSizeInBytes / (1024 * 1024)).toFixed(2)
      if (fileSizeInMB > 2) {
        notificationError('Upload File Image Error', 'File size exceeds the 2 MB limit.')
        return
      }
      setUploadImage(file)
      const fileReader = new FileReader()
      fileReader.readAsDataURL(fileEncoded)
      fileReader.onload = (reader) => {
        setRenderImageUpload(reader.target.result)
      }
    } else {
      setUploadImage(null)
      setRenderImageUpload(null)
    }
  }


  return (
    <Box>
      <Tabs 
        size='xs'
        my={4}
        variant="pills"
        radius="xl"
        value={selectedMethodAdjustImage}
        onChange={(val) => [setSelectedMethodAdjustImage(val), setImageUrl(''), setUploadImage(null), setRenderImageUpload(null)]}>
        <Tabs.List>
          <Tabs.Tab value="url">From URL</Tabs.Tab>
          <Tabs.Tab value="upload">From Local Computer</Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="url">
          <Box my={12}>
            <TextInput
              label='Image URL'
              name='imageUrl'
              value={imageUrl}
              onChange={(val) => setImageUrl(val.target.value)}
              withAsterisk
              size='xs'
            />
          </Box>
        </Tabs.Panel>
        <Tabs.Panel value="upload">
          <Box my={12}>
            <FileInput
              name='uploadImage'
              value={uploadImage}
              label='Upload Image'
              description='File type: jpg, jpeg, png. Max size 2 MB'
              onChange={(val) => handleUploadImage(val)}
              accept="image/jpeg,image/jpg,image/png"
              clearable
              withAsterisk
              size='xs'
            />
          </Box>
        </Tabs.Panel>
      </Tabs>
      <Box>
        <Text fz='md' fw='500'>Preview Image</Text>
        <Box my={20}>
          <Flex gap="xl" justify="center" align="center">
            <Paper shadow="sm" w={302} withBorder radius='md'>
              <Image w={300} h={300} radius='md' fit='cover' src={selectedMethodAdjustImage === 'url' ? imageUrl || NoImage : renderImageUpload || NoImage} />
            </Paper>
          </Flex>
        </Box>
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
            <Button size='xs' variant="filled" loading={loadingSubmit} disabled={imageUrl === '' && renderImageUpload === null} onClick={() => submitAddImageProduct()}>Submit</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAddImageProduct

